"use client";

import React from "react";
import Image from "next/image";
import FeatureItem from "./ui/FeatureItem";

const WhyJoinSection: React.FC = () => {
    return (
        <section className="pt-10 pb-10 sm:pt-16.75 sm:pb-15 bg-white px-4">
            <div className="max-w-306.25 mx-auto">
                <h2 className="font-red-hat text-[30px] sm:text-[32px] md:text-[40px] leading-10 sm:leading-[53px] text-[#1B515E] font-light text-center max-w-4xl mx-auto">
                    Pourquoi rejoindre Spot Formations <br className="hidden md:block" /> en tant que formateur indépendant ?
                </h2>

                <div className="mt-6 sm:mt-13.25 flex flex-col lg:flex-row items-start gap-6 sm:gap-9">
                    {/* Left Column: Static Image */}
                    <div className="w-full lg:w-126.75 shrink-0">
                        <div className='relative w-full aspect-507/264 rounded-3xl overflow-hidden'>
                            <Image
                                src="/assets/video-thumbnail-2.svg"
                                alt="Pourquoi nous rejoindre"
                                fill
                                className='object-cover'
                                priority
                            />
                        </div>
                    </div>

                    {/* Right Column: Features */}
                    <div className="w-full lg:flex-1 space-y-6 sm:space-y-8 sm:mt-3">
                        <div>
                            <h3 className="text-[#1D1D1D] font-medium text-[18px] sm:text-[20px] tracking-[0.2px] leading-6 sm:leading-7.5 mb-3 sm:mb-5">
                                Gagnez du temps, concentrez-vous sur votre cœur de métier : la formation
                            </h3>
                            <p className="text-[#1D1D1D] font-normal text-[14px] sm:text-[16px] leading-5 sm:leading-6.5 tracking-[0.2px]">
                                Chez Spot Formations, nous savons que les formateurs indépendants ont peu de temps pour :
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-1 sm:gap-3">
                            <FeatureItem>Gérer leur prospection</FeatureItem>
                            <FeatureItem>Gérer leur prospection</FeatureItem>
                            <FeatureItem>Maintenir une présence en ligne</FeatureItem>
                            <FeatureItem>Maintenir une présence en ligne</FeatureItem>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyJoinSection;
